import type { InputHTMLAttributes } from "react";
import Tooltip from "ui/popovers/Tooltip";
import styles from "./RadioButton.module.scss";

export interface RadioButtonProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
}

export default function RadioButton({
  checked,
  id,
  name,
  value,
  label = "",
  onClick,
  disabled,
  title,
  ...nativeProps
}: RadioButtonProps) {
  const radioButtonContent = (
    <div className={styles.wrapper}>
      <label htmlFor={id} lang="en" aria-disabled={disabled}>
        <input
          type="radio"
          id={id}
          name={name}
          value={value}
          aria-checked={checked}
          checked={checked}
          disabled={disabled}
          aria-disabled={disabled}
          onClick={onClick}
          {...nativeProps}
        />
        {label}
      </label>
    </div>
  );

  if (disabled && title) {
    return (
      <Tooltip.Root delayDuration={0}>
        <Tooltip.Trigger>{radioButtonContent}</Tooltip.Trigger>
        <Tooltip.Content side="top">{title}</Tooltip.Content>
      </Tooltip.Root>
    );
  }

  return radioButtonContent;
}
